/**
 * @author       Matthieu Devlin (matt@zumper.com)
 * @copyright    Copyright (c) 2023, Zumper
 * @description  populateGeoLocationUrl.ts
 */

import { hyphenate } from '../../../shared/utils/core'
import type { GeoLocation } from './GeoLocation'

export const populateGeoLocationUrl = (geoLocation: GeoLocation): GeoLocation => {
  if (geoLocation && !geoLocation.url) {
    geoLocation.url =
      geoLocation.cityName &&
      geoLocation.stateName &&
      hyphenate(geoLocation.cityName, geoLocation.stateName)
  }
  return geoLocation
}
